/**
 * CashflowChart — Recharts composite chart for monthly tender cashflow.
 *
 * Series:
 *   • Cash Inflow      (green bars)
 *   • Cost Outflow     (red bars, plotted negative)
 *   • Cumulative       (blue line)
 *   • Funding Req.     (orange dashed line — running min cumulative)
 *
 * Accepts the `chartData` payload returned by
 *   GET /api/tenders/cashflows/{id}/monthly?format=chart
 */
import React from 'react';
import {
  ResponsiveContainer, ComposedChart, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, Bar, Line, ReferenceLine,
} from 'recharts';

const fmt = (v) => {
  if (v === null || v === undefined) return '—';
  const abs = Math.abs(v);
  if (abs >= 1e7) return `₹${(v / 1e7).toFixed(1)} Cr`;
  if (abs >= 1e5) return `₹${(v / 1e5).toFixed(1)} L`;
  return `₹${v.toFixed(0)}`;
};

const CashflowChart = ({ data = [] }) => (
  <div className="w-full h-80" data-testid="cashflow-chart">
    <ResponsiveContainer>
      <ComposedChart data={data} margin={{ top: 10, right: 20, bottom: 10, left: 10 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#1F2937" />
        <XAxis dataKey="label" stroke="#94A3B8" fontSize={10}
                tickFormatter={(v) => (v || '').replace(/^20/, '')} interval={2} />
        <YAxis stroke="#94A3B8" fontSize={11} tickFormatter={fmt} width={70} />
        <Tooltip
          contentStyle={{ backgroundColor: '#0F1923', border: '1px solid #1E4E8C', borderRadius: 6 }}
          labelStyle={{ color: '#F1F5F9' }}
          formatter={(v) => fmt(v)}
        />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        <ReferenceLine y={0} stroke="#475569" strokeWidth={1} />
        <Bar dataKey="inflow" fill="#10B981" name="Cash Inflow" />
        <Bar dataKey="outflow" fill="#EF4444" name="Cost Outflow" />
        <Line type="monotone" dataKey="cumulative" stroke="#3B82F6" strokeWidth={2}
              dot={false} name="Cumulative" />
        <Line type="monotone" dataKey="funding" stroke="#F59E0B" strokeWidth={2}
              dot={false} strokeDasharray="4 4" name="Funding Req." />
      </ComposedChart>
    </ResponsiveContainer>
  </div>
);

export default CashflowChart;
